import React, { useState, useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';

const LS_PREFIX = 'elixir_tuto_';

export default function ModuleTutorial({ moduleId, steps, onDone }) {
  const key = LS_PREFIX + moduleId;
  const [step, setStep] = useState(0);
  const [visible, setVisible] = useState(!localStorage.getItem(key));

  if (!visible || !steps || steps.length === 0) return null;

  const s = steps[step];
  const total = steps.length;

  function next() {
    if (step < total - 1) setStep(step + 1);
    else finish();
  }
  function prev() { if (step > 0) setStep(step - 1); }
  function finish() {
    localStorage.setItem(key, '1');
    setVisible(false);
    if (onDone) onDone();
  }
  function restart() { setStep(0); }

  const overlay = (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 9999,
      background: 'rgba(0,0,0,0.85)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: 16, overflowY: 'auto',
    }}>
      <div style={{
        background: 'white', borderRadius: 20, maxWidth: 400, width: '100%',
        overflow: 'hidden', boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
        maxHeight: '90vh', overflowY: 'auto',
      }}>
        {/* Content */}
        <div style={{ padding: '24px 22px 14px' }}>
          {s.icon && <div style={{ fontSize: 44, textAlign: 'center', marginBottom: 8 }}>{s.icon}</div>}
          <div style={{ fontSize: 17, fontWeight: 700, color: '#1A1D23', marginBottom: 8, textAlign: 'center' }}>{s.title}</div>
          <div style={{ fontSize: 13, color: '#4B5563', lineHeight: 1.7, marginBottom: s.tip ? 10 : 0 }}>{s.text}</div>
          {s.tip && (
            <div style={{
              padding: '8px 12px', borderRadius: 8, marginTop: 10,
              background: s.tip.startsWith('⚠️') ? '#FEF3CD' : '#F0F7FF',
              border: '0.5px solid ' + (s.tip.startsWith('⚠️') ? '#F0C36D' : '#85B7EB'),
              fontSize: 12, color: s.tip.startsWith('⚠️') ? '#92710C' : '#1A5276',
              lineHeight: 1.5,
            }}>{s.tip}</div>
          )}
          {s.visual && (
            <div style={{ marginTop: 12, borderRadius: 10, overflow: 'hidden', border: '1px solid #E8E8EE' }}>
              {s.visual}
            </div>
          )}
        </div>

        {/* Progress */}
        <div style={{ padding: '0 22px 8px', display: 'flex', alignItems: 'center', gap: 8 }}>
          <div style={{ flex: 1, height: 4, borderRadius: 2, background: '#E5E7EB' }}>
            <div style={{
              height: '100%', borderRadius: 2, background: '#1A5276',
              width: ((step + 1) / total * 100) + '%', transition: 'width 0.3s',
            }}></div>
          </div>
          <span style={{ fontSize: 10, color: '#9CA3AF', fontWeight: 600 }}>{step + 1}/{total}</span>
        </div>

        {/* Buttons */}
        <div style={{ padding: '0 22px 16px', display: 'flex', gap: 6 }}>
          {step > 0 && (
            <button onClick={prev} style={{
              padding: '12px 16px', borderRadius: 10, border: '1.5px solid #E8E8EE',
              background: 'white', color: '#6B7280', fontSize: 14, fontWeight: 600,
              cursor: 'pointer', fontFamily: 'inherit',
            }}>←</button>
          )}
          <button onClick={finish} style={{
            flex: 1, padding: '12px 8px', borderRadius: 10, border: '1.5px solid #E8E8EE',
            background: 'white', color: '#9CA3AF', fontSize: 12, fontWeight: 500,
            cursor: 'pointer', fontFamily: 'inherit',
          }}>Passer</button>
          <button onClick={next} style={{
            flex: 2, padding: '12px 8px', borderRadius: 10, border: 'none',
            background: '#1A5276', color: 'white', fontSize: 14, fontWeight: 700,
            cursor: 'pointer', fontFamily: 'inherit',
          }}>{step < total - 1 ? 'Suivant →' : 'C\'est compris !'}</button>
        </div>

        {step >= 2 && (
          <div style={{ textAlign: 'center', paddingBottom: 12 }}>
            <button onClick={restart} style={{
              background: 'none', border: 'none', color: '#9CA3AF', fontSize: 11,
              cursor: 'pointer', fontFamily: 'inherit', textDecoration: 'underline',
            }}>↺ Recommencer</button>
          </div>
        )}
      </div>
    </div>
  );

  // Render dans document.body via portal — échappe au stacking context parent
  return createPortal(overlay, document.body);
}

export function resetModuleTutorial(moduleId) {
  localStorage.removeItem(LS_PREFIX + moduleId);
}

export function resetAllTutorials() {
  ['global', 'prep', 'reception_t', 'reception_p', 'export'].forEach(id => {
    localStorage.removeItem(LS_PREFIX + id);
  });
}
